"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RefreshIcon = void 0;
var Preact = __importStar(require("preact"));
var SvgIcon_1 = __importDefault(require("@mui/material/SvgIcon"));
/** Made by opening the svg exported from figma and manually copying the relevant bits into an
 * SvgIcon (and removing fill so it obeys colour setting).
 * Please see https://mui.com/material-ui/icons/#svgicon
 */
function RefreshIcon(props) {
    return (Preact.h(SvgIcon_1.default, __assign({ width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, props),
        Preact.h("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M4.92893 4.92893C8.83418 1.02369 15.1658 1.02369 19.0711 4.92893C20.4536 6.31149 21.348 8.00086 21.7514 9.77873C21.8736 10.3173 21.536 10.853 20.9974 10.9752C20.4588 11.0974 19.9232 10.7599 19.801 10.2213C19.4786 8.80057 18.7648 7.45114 17.6569 6.34315C14.5327 3.21895 9.46734 3.21895 6.34315 6.34315C5.16477 7.52152 4.38627 8.38307 3.87429 9H8C8.55228 9 9 9.44772 9 10C9 10.5523 8.55228 11 8 11H2C1.44772 11 1 10.5523 1 10V4C1 3.44772 1.44772 3 2 3C2.55228 3 3 3.44772 3 4V6.95359C3.49975 6.39509 4.13094 5.72692 4.92893 4.92893ZM3.00256 13.0248C3.54115 12.9026 4.07684 13.2401 4.19904 13.7787C4.52139 15.1994 5.23515 16.5489 6.34315 17.6569C9.46734 20.781 14.5327 20.781 17.6569 17.6569C18.8352 16.4785 19.6137 15.6169 20.1257 15H16C15.4477 15 15 14.5523 15 14C15 13.4477 15.4477 13 16 13H22C22.5523 13 23 13.4477 23 14V20C23 20.5523 22.5523 21 22 21C21.4477 21 21 20.5523 21 20V17.0464C20.5003 17.6049 19.8691 18.2731 19.0711 19.0711C15.1658 22.9763 8.83418 22.9763 4.92893 19.0711C3.54638 17.6885 2.652 15.9991 2.24862 14.2213C2.12641 13.6827 2.46396 13.147 3.00256 13.0248Z" })));
}
exports.RefreshIcon = RefreshIcon;
